const toggleEventsFilterModal = {
	el: {
		body: document.querySelector('body'),
		filterContainer: document.querySelector('.filter'),
		filterInputAndSelectListener: document.querySelectorAll('.js-filter-change-listener'),
		toggleModalButton: document.querySelectorAll('.js-filter-toggle-modal'),
		filterTabs: document.querySelectorAll('[data-filter-tab]')
	},

	vars: {
		extraLargeAndUp: window.matchMedia('(min-width: 75em)')
	},

	fxHideSelectionsOnTwoFieldset(valueSelected, filterTypeSelected, firstFieldsetName, secondFieldsetName, firstOptionSelectOnSecondFieldset, dataAttributeName) {
		// Check if selected filter is category that might filter subCategories on next select
		if (filterTypeSelected === firstFieldsetName) {

			// reset data filter type on subCategories containers
			document.querySelectorAll(`[data-filter-type="${secondFieldsetName}"]`).forEach(el => {
				// reset value on atribute data-filter-id
				el.setAttribute('data-filter-id', '')

				// reset input checked to allSubCategories
				document.querySelector(`input[value="${firstOptionSelectOnSecondFieldset}"]`).checked = true
				// reset select option to allSubCategories
				document.querySelector(`[value="${firstOptionSelectOnSecondFieldset}"`).selected = true
			})

			// set hidden to every subCategory SELECTS
			document.querySelectorAll(`option[${dataAttributeName}]`).forEach(el => el.setAttribute('hidden', 'hidden'))

			// remove hidden to subCategory SELECTED
			document.querySelectorAll(`option[${dataAttributeName}="${valueSelected}"]`).forEach(el => el.removeAttribute('hidden'))

			// set hidden to every subCategory RADIO BUTTONS
			document.querySelectorAll(`div[${dataAttributeName}]`).forEach(el => el.style.display = 'none')

			// remove hidden to subCategory RADIO BUTTONS
			document.querySelectorAll(`div[${dataAttributeName}="${valueSelected}"]`).forEach(el => el.style.display = 'block')
		}
	},

	fxHandleSelectAndInputValue(el) {
		// Check if the element exists
		if (!el) return

		// Get the value of the element
		const valueSelected = el.currentTarget.value
		// Get filter type of element selected
		const getFilterTypeSelected = el.currentTarget.closest('[data-filter-type]').getAttribute('data-filter-type')

		// find filter type of element selected and set atribute to filter id
		document.querySelectorAll(`[data-filter-type="${getFilterTypeSelected}"]`).forEach(el => {
			el.setAttribute('data-filter-id', valueSelected)
		})

		this.fxHideSelectionsOnTwoFieldset(valueSelected, getFilterTypeSelected, 'category', 'subCategory', 'allSubCategories', 'data-category')

		this.fxHideSelectionsOnTwoFieldset(valueSelected, getFilterTypeSelected, 'regionEvents', 'locationEvents', 'allLocations', 'data-region')

		// find input element and set value as value selected
		document.querySelector(`input[value="${valueSelected}"]`).checked = valueSelected
		// find select element and set value as value selected
		document.querySelector(`[value="${valueSelected}"`).parentElement.value = valueSelected
	},

	fxHandleToggleModal(el) {
		if (!el) return
		// Check if the modal is open
		if (el.currentTarget.closest('.filter').classList.contains('filter-modal-active')) {
			this.el.body.classList.remove('no-scroll-hidden')
			el.currentTarget.closest('.filter').classList.remove('filter-modal-active')
		} else {
			this.el.body.classList.add('no-scroll-hidden')
			el.currentTarget.closest('.filter').classList.add('filter-modal-active')
		}
	},

	fxWatchResizeForCloseModal() {
		if (!this.el.filterContainer) return

		// Condition that make sure when user is resizing the screen the page will not be locked with scroll hidden
		if (this.vars.extraLargeAndUp.matches && this.el.filterContainer.classList.contains('filter-modal-active')) {
			this.el.filterContainer.classList.remove('filter-modal-active')
			this.el.body.classList.remove('no-scroll-hidden')
		}
	},

	init() {
		// Responsible for toggling the filter modal
		this.el.toggleModalButton.forEach(el => el.addEventListener('click', e => this.fxHandleToggleModal(e)))

		// Responsible for set values of radio buttons and select elements on data attribute called "data filter id" and make sure that when user select mobile version, the desktop version is selected as well
		this.el.filterInputAndSelectListener.forEach(el => el.addEventListener('change', e => this.fxHandleSelectAndInputValue(e)))

		// resize event for window - Responsible for check if the modal is active and if it is, then it will remove the active class
		window.addEventListener('resize', () => this.fxWatchResizeForCloseModal())
	}
}

toggleEventsFilterModal.init()